<h2>{{ 'EDIT_EXHIBITOR_EXHIBITOR.TITLE' | translate }}</h2>
<div class="section-container">
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="form-group" [ngClass]="{ 'has-error': name.invalid && (name.dirty || name.touched), 'has-success': name.valid }">
        <label for="name">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.NAME_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['name']" name="name" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.NAME_PLACEHOLDER' | translate }}" #name="ngModel">
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group" [ngClass]="{ 'has-error': address.invalid && (address.dirty || address.touched), 'has-success': address.valid }">
        <label for="address">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.ADDRESS_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['addressLine1']" address="address" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.ADDRESS_PLACEHOLDER' | translate }}" #address="ngModel">
      </div>
    </div>
  </div>
  <div class="row">

    <div class="col-12 col-md-6">
      <div class="form-group" [ngClass]="{ 'has-error': zipCode.invalid && (zipCode.dirty || zipCode.touched), 'has-success': zipCode.valid }">
        <label for="zipCode">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.ZIP_CODE_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['zipCode']" zipCode="zipCode" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.ZIP_CODE_PLACEHOLDER' | translate }}" #zipCode="ngModel">
      </div>
    </div>

    <div class="col-12 col-md-6">
      <div class="form-group" [ngClass]="{ 'has-error': phone.invalid && (phone.dirty || phone.touched), 'has-success': phone.valid }">
        <label for="phone">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.PHONE_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['telephone']" phone="phone" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.PHONE_PLACEHOLDER' | translate }}" #phone="ngModel">
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="form-group" [ngClass]="{ 'has-error': country.invalid && (country.dirty || country.touched), 'has-success': country.valid }">
        <label for="country">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.COUNTRY_LABEL' | translate }}</label>
        <select id="country" class="form-control" [(ngModel)]="exhibitorData['exhibitor']['countryId']" name="country" #country="ngModel" required>
          <option value="" disabled>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.COUNTRY_PLACEHOLDER' | translate }}</option>
          <option [value]="country['id']" *ngFor="let country of countries">{{ utilsService._api(country.translations, 'translation') }}</option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="form-group" [ngClass]="{ 'has-error': city.invalid && (city.dirty || city.touched), 'has-success': city.valid }">
        <label for="city">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CITY_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['city']" city="city" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CITY_PLACEHOLDER' | translate }}" #city="ngModel">
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group" [ngClass]="{ 'has-error': province.invalid && (province.dirty || province.touched), 'has-success': province.valid }">
        <label for="province">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.PROVINCE_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['province']" province="province" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.PROVINCE_PLACEHOLDER' | translate }}" #province="ngModel">
      </div>
    </div>

  </div>
  <div class="row">

    <div class="col-12 col-md-4">
      <div class="form-group" [ngClass]="{ 'has-error': sector.invalid && (sector.dirty || sector.touched), 'has-success': sector.valid }">
        <label for="sector">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.SECTOR_LABEL' | translate }}</label>
        <select id="sector" class="form-control" [(ngModel)]="exhibitorData['exhibitor']['sectorId']" name="sector" #sector="ngModel" required [disabled]="!rolesService.hasRoles([roles['BACKOFFICE'], roles['SUPERADMIN']])">
          <option value="" disabled>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.SECTOR_PLACEHOLDER' | translate }}</option>
          <option [value]="sector['id']" *ngFor="let sector of sectors">{{ utilsService._api(sector.translations, 'name') }}</option>
        </select>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group" [ngClass]="{ 'has-error': stand.invalid && (stand.dirty || stand.touched), 'has-success': stand.valid }">
        <label for="stand">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.STAND_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['standLocation']" stand="stand" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.STAND_PLACEHOLDER' | translate }}" #stand="ngModel" [readonly]="!rolesService.hasRoles([roles['BACKOFFICE'], roles['SUPERADMIN']])">
      </div>
    </div>


    <div class="col-12 col-md-4">
      <div class="form-group" [ngClass]="{ 'has-error': webSite.invalid && (webSite.dirty || webSite.touched), 'has-success': webSite.valid }">
        <label for="webSite">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.WEBSITE_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['webSite']" webSite="webSite" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.WEBSITE_PLACEHOLDER' | translate }}" #webSite="ngModel">
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="form-group" [ngClass]="{ 'has-error': email.invalid && (email.dirty || email.touched), 'has-success': email.valid }">
        <label for="email">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.EMAIL_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['email']" email="email" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.EMAIL_PLACEHOLDER' | translate }}" #email="ngModel">
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-2">
      <div class="form-group" [ngClass]="{ 'has-error': facebookUrl.invalid && (facebookUrl.dirty || facebookUrl.touched), 'has-success': facebookUrl.valid }">
        <label for="facebookUrl">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.FACEBOOK_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['facebookUrl']" facebookUrl="facebookUrl" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.FACEBOOK_PLACEHOLDER' | translate }}" #facebookUrl="ngModel">
      </div>
    </div>

    <div class="col-12 col-md-2">
      <div class="form-group" [ngClass]="{ 'has-error': twitterUrl.invalid && (twitterUrl.dirty || twitterUrl.touched), 'has-success': twitterUrl.valid }">
        <label for="twitterUrl">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.TWITTER_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['twitterUrl']" twitterUrl="twitterUrl" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.TWITTER_PLACEHOLDER' | translate }}" #twitterUrl="ngModel">
      </div>
    </div>

    <div class="col-12 col-md-2">
      <div class="form-group" [ngClass]="{ 'has-error': linkedInUrl.invalid && (linkedInUrl.dirty || linkedInUrl.touched), 'has-success': linkedInUrl.valid }">
        <label for="linkedInUrl">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.LINKEDIN_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['linkedInUrl']" linkedInUrl="linkedInUrl" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.LINKEDIN_PLACEHOLDER' | translate }}" #linkedInUrl="ngModel">
      </div>
    </div>

    <div class="col-12 col-md-2">
      <div class="form-group" [ngClass]="{ 'has-error': pinterestUrl.invalid && (pinterestUrl.dirty || pinterestUrl.touched), 'has-success': pinterestUrl.valid }">
        <label for="pinterestUrl">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.PINTEREST_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['pinterestUrl']" pinterestUrl="pinterestUrl" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.PINTEREST_PLACEHOLDER' | translate }}" #pinterestUrl="ngModel">
      </div>
    </div>


    <div class="col-12 col-md-2">
      <div class="form-group" [ngClass]="{ 'has-error': instagramUrl.invalid && (instagramUrl.dirty || instagramUrl.touched), 'has-success': instagramUrl.valid }">
        <label for="instagramUrl">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.INSTAGRAM_LABEL' | translate }}</label>
        <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['instagramUrl']" instagramUrl="instagramUrl" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.INSTAGRAM_PLACEHOLDER' | translate }}" #instagramUrl="ngModel">
      </div>
    </div>
  </div>
</div>

<h3>{{ 'EDIT_EXHIBITOR_EXHIBITOR.CONTACT_INFORMATION_SUBTITLE' | translate }}</h3>
<div class="section-container">
  <div class="col" *ngIf="detailsService.getPropertyByKey('digital.app.enabled', true)">
      {{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_INFO_ONE' | translate }}
      <b> {{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_INFO_TWO' | translate }} </b> 
      <a  [href]="detailsService.getPropertyByKey('digital.app.accreditation.url')" target="_blank" [ngStyle]="detailsService.getPropertyByKey('digital.app.accreditation.url') == 'https://' ? {pointerEvents: 'none'} : null">
        {{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_INFO_THREE' | translate }}
      </a>
      {{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_INFO_FOUR' | translate }}
  </div>
  <div class="col">
    <div class="form-group" [ngClass]="{ 'has-error': contactName.invalid && (contactName.dirty || contactName.touched), 'has-success': contactName.valid }">
      <label for="contactName">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_NAME_LABEL' | translate }}</label>
      <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['contactName']" contactName="contactName" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_NAME_PLACEHOLDER' | translate }}" #contactName="ngModel">
    </div>
  </div>
  <div class="col">
    <div class="form-group" [ngClass]="{ 'has-error': contactTelephone.invalid && (contactTelephone.dirty || contactTelephone.touched), 'has-success': contactTelephone.valid }">
      <label for="contactTelephone">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_TELEPHONE_LABEL' | translate }}</label>
      <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['contactTelephone']" contactTelephone="contactTelephone" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_TELEPHONE_PLACEHOLDER' | translate }}" #contactTelephone="ngModel">
    </div>
  </div>
  <div class="col">
    <div class="form-group" [ngClass]="{ 'has-error': contactPost.invalid && (contactPost.dirty || contactPost.touched), 'has-success': contactPost.valid }">
      <label for="contactPost">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_POST_LABEL' | translate }}</label>
      <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['contactPost']" contactPost="contactPost" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_POST_PLACEHOLDER' | translate }}" #contactPost="ngModel">
    </div>
  </div>
  <div class="col">
    <div class="form-group" [ngClass]="{ 'has-error': contactEmail.invalid && (contactEmail.dirty || contactEmail.touched), 'has-success': contactEmail.valid }">
      <a class="alert-icon" data-toggle="tooltip" [title]="'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_EMAIL_TOOLTIP'| translate" *ngIf="detailsService.getPropertyByKey('digital.app.enabled', true)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation" style="margin-bottom: 2.5px;" viewBox="0 0 16 16">
          <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0z"/>
        </svg>
      </a>
      <label for="contactEmail">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_EMAIL_LABEL' | translate }}</label>
      <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['contactEmail']" contactEmail="contactEmail" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CONTACT_EMAIL_PLACEHOLDER' | translate }}" #contactEmail="ngModel">
    </div>
  </div>
</div>

<h3>{{ 'EDIT_EXHIBITOR_EXHIBITOR.DESCRIPTION_SUBTITLE' | translate }}</h3>
<div class="section-container">
  <app-translated-fields [exhibitorData]="exhibitorData" [type]="'exhibitor'" [eventName]="eventName" [selectedOds]="selectedOds"></app-translated-fields>
</div>

<h3>{{ 'EDIT_EXHIBITOR_EXHIBITOR.BRANDS_SUBTITLE' | translate }}</h3>
<div class="section-container">
  <div class="col">
    <div class="form-group" [ngClass]="{ 'has-error': brands.invalid && (brands.dirty || brands.touched), 'has-success': brands.valid }">
      <label for="brands">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.BRANDS_LABEL' | translate }}</label>
      <input type="text" required class="form-control" [(ngModel)]="exhibitorData['exhibitor']['brand']" maxLength="500" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.BRANDS_PLACEHOLDER' | translate }}" #brands="ngModel">
    </div>
  </div>
  <div class="col" *ngIf="exhibitorData['exhibitor']['brand']">
    <span>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.BRANDS_CHARACTER_COUNT' | translate }} {{ exhibitorData['exhibitor']['brand'].length}} / 500</span>
  </div>
  <ul class="nav" *ngIf="exhibitorData['exhibitor']['brand']">
    <li class="custom-brand-list" *ngFor="let brand of exhibitorData['exhibitor']['brand'].split(','); trackBy: utilsService.trackByItems" (click)="removeBrand(brand)" >
      <span>{{ brand }}</span>
      <img class="pointer remove-item-img" width="16" height="16"  src="assets/img/close_white.svg" >
    </li>
  </ul>
</div>
